export function getRandomNumber(minValue: number, maxValue: number): number {
  if (minValue > maxValue) {
    [minValue, maxValue] = [maxValue, minValue];
  }
  return Math.floor(Math.random() * (maxValue - minValue + 1)) + minValue;
}
